import { createFileRoute } from '@tanstack/react-router';

import {
    agentNotesSearchSchema,
    NoteDetailPage,
} from '@apps/web/features/admin_agent_notes';

export const Route = createFileRoute('/_app/admin/agent-notes/$note-id')({
    validateSearch: agentNotesSearchSchema,
    head: () => ({
        meta: [
            {
                title: 'Agent Note | Phoebe Admin',
            },
        ],
    }),
    component: NoteDetailPage,
});
